import { TextSource } from './types';

/**
 * Der feste Rahmen rund um die Beiträge: Überschriften, Beschriftungen, Hinweise.
 *
 * Die Beiträge selbst stehen weiterhin in `newsData.ts` und sind noch nicht
 * bearbeitbar — sie brauchen eine eigene Redaktionsmaske samt Bild-Upload.
 */
export const AKTUELLES: TextSource = {
  'aktuelles.hero.eyebrow': 'Aktuelles',
  'aktuelles.hero.titel': 'Neuigkeiten aus',
  'aktuelles.hero.titel-akzent': 'Gifhorn & der Region.',
  'aktuelles.hero.lead': 'Einblicke, Termine und Momente aus dem Alltag der Seniorenbetreuung Antczak.',
  'aktuelles.neuester.marke': { text: 'Neuester Beitrag', max: 30 },
  'aktuelles.beitrag.link': { text: 'Beitrag lesen', max: 30 },

  'artikel.zurueck': { text: 'Alle Beiträge', max: 30 },
  'artikel.galerie.titel': 'Bildergalerie',
  'artikel.weitere.titel': 'Weitere Beiträge',
  'artikel.fehlt.eyebrow': 'Aktuelles',
  'artikel.fehlt.titel': 'Diesen Beitrag gibt es',
  'artikel.fehlt.titel-akzent': 'nicht mehr.',
  'artikel.fehlt.text':
    'Vielleicht wurde er verschoben oder umbenannt. In der Übersicht finden Sie alle Beiträge.',
  'artikel.fehlt.cta': 'Zu allen Beiträgen',

  'fehlerseite.eyebrow': { text: '404', max: 20 },
  'fehlerseite.titel': 'Diese Seite gibt es',
  'fehlerseite.titel-akzent': 'leider nicht.',
  'fehlerseite.text':
    'Vielleicht wurde sie verschoben oder umbenannt. Rufen Sie uns gerne an — wir helfen Ihnen direkt weiter.',
  'fehlerseite.cta': 'Zur Startseite',
};

export default AKTUELLES;
